import {Part} from "../part";
import {PartMenuType} from "../../../visComponents/constants";
import { showerAccessoriesThumbnail } from '../../../bvComponent/core/assets';
import LargeCornerSeat from "../subparts/showerAccessories/largeCornerSeat";
import SoapDish from "../subparts/showerAccessories/soapDish";
import CornerCaddie from "../subparts/showerAccessories/cornerCaddie";
import LargeCornerCaddie from "../subparts/showerAccessories/largeCornerCaddie";
import GrabBar from "../subparts/showerAccessories/grabBar";
import CornerShelf from "../subparts/showerAccessories/cornerShelf";
import ShowerPod from "../subparts/showerAccessories/showerPod";
import Seats from "../subparts/showerAccessories/seats";
import ShowerRod from "../subparts/showerAccessories/showerRod";
import WindowBody from "../subparts/showerAccessories/windowBody";
import WindowKits from "../subparts/showerAccessories/windowKits";
import LargeShelf from "../subparts/showerAccessories/largeShelf";
import TowelBar from "../subparts/showerAccessories/towelBar";
import ShampooShelf from "../subparts/showerAccessories/shampooShelf";
import SeatPad from "../subparts/showerAccessories/seatPad";
import LShapedGrabBar from "../subparts/showerAccessories/lShapedGrabBar";
import HandShowerKit from "../subparts/showerAccessories/handShowerKit";
import HandleShowerValve from "../subparts/showerAccessories/handleShowerValve";

export class ShowerAccessories extends Part {
  static id = 'Shower Accessories';

  constructor() {
    super(true, false, PartMenuType.Complex);

    this.menuType = PartMenuType.Complex;
    this.partThumbnail = showerAccessoriesThumbnail;
    this.partName = 'Shower Accessories';
    this.translateId = "visualizer.bathroom.accessories";
    this.relatedItems = [];

    // related items
    this.soapDish = null;
    this.largeCornerSeat = null;
    this.largeCornerCaddie = null;
    this.cornerCaddie = null;
    this.smallCornerShelf = null;
    this.grabBar = null;
    this.showerPod = null;
    this.seats = null;
    this.windowBody = null;
    this.windowKits = null;
    this.largeShelf = null;
    this.shampooShelf = null;
    this.towelBar = null;
    this.seatPad = null;
    this.lShapedGrabBar = null;
    this.handShowerKit = null;
    this.handleShowerValve = null;

    //current active caddie type
    this.caddie_type = "corner_shelf";

  }

  load(dbFeature) {
    let relatedItemName = "",
      RelatedItemClass = null;
    switch (dbFeature.groupName) {
      case "Soap Dish":
        relatedItemName = "soapDish";
        RelatedItemClass = SoapDish;
        break;
      case "Large Corner Seat":
        relatedItemName = "largeCornerSeat";
        RelatedItemClass = LargeCornerSeat;
        break;
      case "Large Corner Caddie":
        relatedItemName = "largeCornerCaddie";
        RelatedItemClass = LargeCornerCaddie;
        break;
      case "Corner Caddie":
        relatedItemName = "cornerCaddie";
        RelatedItemClass = CornerCaddie;
        break;
      case "Grab Bar":
        relatedItemName = "grabBar";
        RelatedItemClass = GrabBar;
        break;
      case "Shower Rod":
        relatedItemName = "showerRod";
        RelatedItemClass = ShowerRod;
        break;
      case "Corner Shelf":
      case "Small Corner Shelf":
        relatedItemName = "cornerShelf";
        RelatedItemClass = CornerShelf;
        break;
      case "Shower Pod":
      case "Storage Pod":
      case "Storage Pods":
        relatedItemName = "showerPod";
        RelatedItemClass = ShowerPod;
        break;
      case "Large Shelf":
        relatedItemName = "largeShelf";
        RelatedItemClass = LargeShelf;
        break;
      case "Shampoo Shelf":
        relatedItemName = "shampooShelf";
        RelatedItemClass = ShampooShelf;
        break;
      case "Seats":
      case "flip-Up Seat":
      case "Flip-Up Seat":
        relatedItemName = "seats";
        RelatedItemClass = Seats;
        break;
      case "Window Kit":
      case "Window Kits": {
        relatedItemName = "windowKits";
        RelatedItemClass = WindowKits;
        break;
      }
      case "Window": {
        relatedItemName = "decorWindow";
        RelatedItemClass = WindowBody;
        break;
      }
      case "Towel Bar": {
        relatedItemName = "towelBar";
        RelatedItemClass = TowelBar;
        break;
      }
      case "Seat Pad":
        relatedItemName = "seatPad";
        RelatedItemClass = SeatPad;
        break;
      case "L Shaped Grab Bar":
        relatedItemName = "lShapedGrabBar";
        RelatedItemClass = LShapedGrabBar;
        break;
      case "Hand Shower Kit":
        relatedItemName = "handShowerKit";
        RelatedItemClass = HandShowerKit;
        break;
      case "Handle Shower Valve":
        relatedItemName = "handleShowerValve";
        RelatedItemClass = HandleShowerValve;
        break;

    }
    if (relatedItemName) {
      if (!this[relatedItemName]) {
        this[relatedItemName] = new RelatedItemClass(true);
        if (relatedItemName !== "shadows") {
          this.relatedItems.push(this[relatedItemName]);
        }
      }
      if (!this.categoryEnabled) {
        this.categoryEnabled = true
      }
      this[relatedItemName].getParent = () => this;
      this[relatedItemName].load(dbFeature);
      return true
    }
    return false
  }

}

